import { Validator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/Validator';
export class MergeContactActionSettingsValidator extends Validator {
    validate(model) {
    }
}
